import translate from '@i18n'
import { FunctionComponent } from 'react'
import styled from 'styled-components'

const InfoBox = styled.div`
  text-align: left;
  box-sizing: border-box;
  padding: 1.25rem;
  background-color: ${({ theme }) => theme.colors.grey.grey_20};
  color: ${({ theme }) => theme.colors.grey.grey_80};
  font-family: ${({ theme }) => theme.fonts.sourceSansPro};
  font-size: 16px;
  line-height: 1.22;
  font-style: italic;
`

const CommentingInfoBox: FunctionComponent = () => {
  return <InfoBox>{translate('commenting.noAvailableComments')}</InfoBox>
}

export default CommentingInfoBox
